import React from 'react';
import LogoImg from'./SternsLogo.png'
const Logo = () => {
    return(
        <div className="w3">
            <img className="w3" src={LogoImg} alt=""/>
        </div>
    );
}
export default Logo;